var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C2233"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.666 10H24.335C27.723 10 30 12.378 30 15.917V24.084C30 27.623 27.723 30 24.334 30H15.666C12.277 30 10 27.623 10 24.084V15.917C10 12.378 12.277 10 15.666 10ZM25.761 21.8519C25.761 22.2659 25.425 22.6019 25.011 22.6019C24.597 22.6019 24.261 22.2659 24.261 21.8519V20.7499H22.931V21.8519C22.931 22.2659 22.595 22.6019 22.181 22.6019C21.767 22.6019 21.431 22.2659 21.431 21.8519V20.7499H19.319C18.995 21.8179 18.013 22.6019 16.841 22.6019C15.407 22.6019 14.24 21.4349 14.24 19.9999C14.24 18.5659 15.407 17.3989 16.841 17.3989C18.013 17.3989 18.995 18.1829 19.319 19.2499H25.011C25.425 19.2499 25.761 19.5859 25.761 19.9999V21.8519ZM16.8411 18.8989C16.2341 18.8989 15.7391 19.3929 15.7391 20.0009C15.7391 20.6079 16.2341 21.1019 16.8411 21.1019C17.4481 21.1019 17.9431 20.6079 17.9431 20.0009C17.9431 19.3929 17.4481 18.8989 16.8411 18.8989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon (2).0a0b348f4a2ac644432bb7b97978a698.svg";
export { ForwardRef as ReactComponent };